// extracted by mini-css-extract-plugin
module.exports = {"list":"FooterList_list__DMs1l","title":"FooterList_title__JjhBx"};